module.exports = __webpack_public_path__ + "static/img/Verizon.f0ca84bb.png";